var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone_",
    "data-name": "phone ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.077,
    height: 38.114,
    viewBox: "0 0 37.077 38.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_10",
    "data-name": "Path 10",
    d: "M10.185,0A3.278,3.278,0,0,1,12,1.041a3.1,3.1,0,0,1,.718,1.9,32.4,32.4,0,0,0,.25,3.331,32.616,32.616,0,0,0,.849,3.715,3.1,3.1,0,0,1-.633,2.807c-1.054,1.384-2.061,2.8-3.1,4.2-.108.145-.046.235.017.353a23.665,23.665,0,0,0,9.6,10.1c.74.418.735.431,1.395-.084,1.26-.989,2.52-1.986,3.8-2.966a2.639,2.639,0,0,1,2.4-.471c1.071.287,2.127.631,3.22.817a16.535,16.535,0,0,0,3.163.3A3.119,3.119,0,0,1,37.1,27.74v7.734a2.82,2.82,0,0,1-1.94,2.516,2.461,2.461,0,0,1-.925.118A31.574,31.574,0,0,1,20.865,35.39a33.156,33.156,0,0,1-7.843-4.778,33.878,33.878,0,0,1-3.334-3.068A35.74,35.74,0,0,1,1.041,11.771,30.7,30.7,0,0,1,.1,5.913a32.964,32.964,0,0,1-.05-3.448A2.787,2.787,0,0,1,2.49.038.138.138,0,0,0,2.588,0Z",
    transform: "translate(-0.025)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.87d48b335a2c06c73638b65bb5412256.svg";
export { ForwardRef as ReactComponent };